import { PageHero } from "../components/site/Layout";
import { OrderCTA } from "../components/site/OrderCTA";
import { Promotions } from "../components/site/Promotions";
import { ServiceList } from "./Services";
import { ShopGrid } from "./Shop";

export default function ShopServices() {
  return (
    <>
      <PageHero eyebrow="Shop & services" title="Custom pieces for" script="every occasion" testid="shop-services-hero">
        From one-of-a-kind keepsakes to bulk orders for your whole team, here's what we can make for you, plus set-price items you can order and pay for right now.
        <div className="mt-6 flex flex-wrap gap-3" data-testid="shop-services-jump">
          <a href="#services" className="btn-pink !px-6 !py-2.5 text-sm" data-testid="jump-services-btn">Services</a>
          <a href="#shop" className="btn-outline-gold !px-6 !py-2.5 text-sm" data-testid="jump-shop-btn">Shop</a>
        </div>
      </PageHero>
      <ServiceList />
      <ShopGrid />
      <Promotions />
      <OrderCTA />
    </>
  );
}
